// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__uEevc","additionalInfo":"AgreementModal_additionalInfo__2Lw6C"};